import {t} from '@lingui/core/macro';

import {PALETTE} from 'shared/config/model/palette';

import {PaymentStatus} from '../model/PaymentStatus';

export const colorPaymentStatus = (status: PaymentStatus): string => {
    const map = {
        [PaymentStatus.Created]: PALETTE.neutralMuted,
        [PaymentStatus.Paid]: PALETTE.success,
        [PaymentStatus.Canceled]: PALETTE.error,
    };

    return map[status];
};

export const translatePaymentStatus = (status: PaymentStatus): string => {
    const map = {
        [PaymentStatus.Created]: t`Не оплачен`,
        [PaymentStatus.Paid]: t`Оплачен`,
        [PaymentStatus.Canceled]: t`Отменен`,
    };

    return map[status];
};
